// SHADOW MARKET™ — Kids concept animations (pure SVG + CSS keyframes).
import React from "react";

export const AnimacionConcepto = ({ id }) => {
  if (!id) return null;
  if (id === "monedas") {
    return (
      <svg viewBox="0 0 300 130" width="100%" style={{ maxWidth: 320 }}>
        <style>{`
          @keyframes mFall { 0%{transform:translateY(-26px);opacity:0} 100%{transform:translateY(0);opacity:1} }
          @keyframes mGlow { 0%,100%{opacity:.85} 50%{opacity:1} }
          .m1 { animation: mFall .6s 0s ease forwards, mGlow 2.2s 1s infinite; }
          .m2 { animation: mFall .6s .25s ease forwards, mGlow 2.2s 1.25s infinite; opacity: 0; }
          .m3 { animation: mFall .6s .5s ease forwards, mGlow 2.2s 1.5s infinite; opacity: 0; }
          .arr { animation: mGlow 1.4s .8s infinite; }
        `}</style>
        <g className="m1">
          <circle cx="55" cy="65" r="28" fill="#f5a623" stroke="#c4921a" strokeWidth="2" />
          <text x="55" y="71" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#0a0b16">$</text>
        </g>
        <g className="arr">
          <path d="M95 55 L150 55" stroke="#94a3b8" strokeWidth="2" />
          <path d="M148 50 L155 55 L148 60" fill="none" stroke="#94a3b8" strokeWidth="2"/>
          <path d="M150 78 L95 78" stroke="#94a3b8" strokeWidth="2" />
          <path d="M97 73 L90 78 L97 83" fill="none" stroke="#94a3b8" strokeWidth="2"/>
          <text x="123" y="48" textAnchor="middle" fontSize="9" fill="#94a3b8">CAMBIO</text>
        </g>
        <g className="m2">
          <circle cx="190" cy="40" r="22" fill="#ef4444" />
          <text x="190" y="48" textAnchor="middle" fontSize="20">🍎</text>
        </g>
        <g className="m3">
          <circle cx="250" cy="80" r="22" fill="#fbbf24" />
          <text x="250" y="88" textAnchor="middle" fontSize="20">🐔</text>
        </g>
      </svg>
    );
  }
  if (id === "bitcoin-nace") {
    return (
      <svg viewBox="0 0 300 130" width="100%" style={{ maxWidth: 320 }}>
        <style>{`
          @keyframes bScale { 0%{transform:scale(0);opacity:0} 60%{transform:scale(1.18);opacity:1} 100%{transform:scale(1);opacity:1} }
          @keyframes bRay { 0%{opacity:0} 50%{opacity:.8} 100%{opacity:0} }
          .bg-ring { transform-origin: 150px 65px; animation: bScale 1.4s ease forwards; }
          .ray { animation: bRay 1.8s 1s ease infinite; transform-origin: 150px 65px; }
        `}</style>
        {[0, 45, 90, 135].map((deg) => (
          <line
            key={deg}
            className="ray"
            x1="150" y1="65" x2={150 + 70 * Math.cos((deg * Math.PI) / 180)}
            y2={65 + 70 * Math.sin((deg * Math.PI) / 180)}
            stroke="#f5a623" strokeWidth="3" strokeLinecap="round"
            style={{ animationDelay: `${deg * 8}ms` }}
          />
        ))}
        <g className="bg-ring">
          <circle cx="150" cy="65" r="42" fill="#f5a623" stroke="#c4921a" strokeWidth="3" />
          <text x="150" y="78" textAnchor="middle" fontSize="48" fontWeight="bold" fill="#0a0b16">₿</text>
        </g>
        <text x="150" y="120" textAnchor="middle" fontSize="11" fill="#94a3b8">2009</text>
      </svg>
    );
  }
  if (id === "21m") {
    return (
      <svg viewBox="0 0 320 110" width="100%" style={{ maxWidth: 340 }}>
        <style>{`
          @keyframes barGrow { from{width:0} to{width:240px} }
          .bar { animation: barGrow 2s ease forwards; }
        `}</style>
        <text x="10" y="22" fontSize="12" fill="#cbd5e1">Suministro total de Bitcoin · 21.000.000</text>
        <rect x="10" y="32" width="280" height="30" rx="6" fill="#1e293b" stroke="#334155" strokeWidth="1"/>
        <rect className="bar" x="10" y="32" width="0" height="30" rx="6" fill="#f5a623"/>
        <text x="20" y="52" fontSize="12" fontWeight="bold" fill="#0a0b16">~85% minados</text>
        <text x="10" y="82" fontSize="10" fill="#94a3b8">Restan: ~3.150.000 ₿</text>
        <text x="10" y="98" fontSize="10" fill="#94a3b8">Último BTC: año ~2140</text>
      </svg>
    );
  }
  if (id === "wallet") {
    return (
      <svg viewBox="0 0 280 120" width="100%" style={{ maxWidth: 300 }}>
        <style>{`
          @keyframes wOpen { 0%{transform:rotate(0deg)} 50%{transform:rotate(-18deg)} 100%{transform:rotate(0deg)} }
          @keyframes cIn { 0%{transform:translate(-30px,-20px);opacity:0} 100%{transform:translate(0,0);opacity:1} }
          .lid { transform-origin: 90px 30px; animation: wOpen 2.4s 1.2s ease infinite; }
          .coin { animation: cIn 1s .8s ease forwards; opacity: 0; }
        `}</style>
        <rect x="90" y="40" width="120" height="65" rx="10" fill="#1a3a6a" stroke="#f5a623" strokeWidth="2"/>
        <rect x="100" y="55" width="100" height="35" rx="4" fill="rgba(245,166,35,.1)" stroke="rgba(245,166,35,.3)" strokeWidth="1"/>
        <text x="150" y="79" textAnchor="middle" fontSize="20" fontWeight="bold" fill="#f5a623">₿ ₿ ₿</text>
        <g className="lid">
          <rect x="90" y="20" width="120" height="22" rx="6" fill="#f5a623" stroke="#c4921a" strokeWidth="2"/>
          <text x="150" y="36" textAnchor="middle" fontSize="11" fontWeight="bold" fill="#0a0b16">MI WALLET</text>
        </g>
        <g className="coin">
          <circle cx="45" cy="50" r="17" fill="#f5a623" stroke="#c4921a" strokeWidth="2"/>
          <text x="45" y="57" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#0a0b16">₿</text>
        </g>
      </svg>
    );
  }
  if (id === "halving") {
    return (
      <svg viewBox="0 0 320 130" width="100%" style={{ maxWidth: 340 }}>
        <style>{`
          @keyframes barShrink { 0%{height:80px;y:30px} 25%{height:40px;y:70px} 50%{height:20px;y:90px} 75%{height:10px;y:100px} 100%{height:5px;y:105px} }
          .b1 { fill:#f5a623; }
          .b2 { fill:#f5a623; animation: barShrink 6s ease forwards; }
        `}</style>
        <text x="10" y="20" fontSize="12" fill="#cbd5e1">Cada 4 años · Recompensa ÷ 2</text>
        {[0, 1, 2, 3, 4].map((i) => {
          const x = 30 + i * 55;
          const h = 80 / Math.pow(2, i);
          const y = 110 - h;
          return (
            <g key={i}>
              <rect x={x} y={y} width="40" height={h} rx="4" fill="#f5a623" opacity={1 - i * 0.12}/>
              <text x={x + 20} y="125" textAnchor="middle" fontSize="9" fill="#94a3b8">
                {[50, 25, 12.5, 6.25, 3.125][i]}
              </text>
            </g>
          );
        })}
      </svg>
    );
  }
  if (id === "hodl-rocket") {
    return (
      <svg viewBox="0 0 280 130" width="100%" style={{ maxWidth: 300 }}>
        <style>{`
          @keyframes rUp { 0%{transform:translate(0,40px)} 50%{transform:translate(0,-10px)} 100%{transform:translate(0,-60px)} }
          @keyframes flame { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.4)} }
          .rocket { animation: rUp 3s ease infinite alternate; }
          .flame { animation: flame .2s ease infinite alternate; transform-origin: 50px 100px; }
        `}</style>
        <text x="140" y="20" textAnchor="middle" fontSize="11" fill="#94a3b8">📈 HODL → 🚀</text>
        <g className="rocket">
          {/* Body */}
          <ellipse cx="50" cy="80" rx="18" ry="32" fill="#f5a623" stroke="#c4921a" strokeWidth="2"/>
          <text x="50" y="88" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#0a0b16">₿</text>
          <circle cx="50" cy="65" r="6" fill="#1a3a6a" stroke="#0a0b16" strokeWidth="1"/>
          {/* Fins */}
          <path d="M32 95 L20 110 L32 105 Z" fill="#ef4444"/>
          <path d="M68 95 L80 110 L68 105 Z" fill="#ef4444"/>
          {/* Flame */}
          <g className="flame">
            <path d="M38 110 L50 130 L62 110 Z" fill="#fbbf24"/>
            <path d="M42 110 L50 124 L58 110 Z" fill="#ef4444"/>
          </g>
        </g>
        {/* Price chart */}
        <polyline points="100,110 130,90 160,100 190,60 220,70 260,30" fill="none" stroke="#00c864" strokeWidth="3"/>
      </svg>
    );
  }
  return null;
};
